import { queryOptions } from "@tanstack/react-query";

import {
  getGallery,
  getHomeData,
  getItem,
  getList,
  getPage,
  getSiteSettings,
} from "./public-data.functions";

export const settingsQuery = () =>
  queryOptions({
    queryKey: ["site_settings"],
    queryFn: () => getSiteSettings(),
    staleTime: 60_000,
  });

export const homeQuery = () =>
  queryOptions({
    queryKey: ["home"],
    queryFn: () => getHomeData(),
    staleTime: 30_000,
  });

export const listQuery = (table: string, limit?: number) =>
  queryOptions({
    queryKey: ["list", table, limit ?? null],
    queryFn: () => getList({ data: { table: table as never, limit } }),
    staleTime: 30_000,
  });

export const itemQuery = (table: string, slug: string) =>
  queryOptions({
    queryKey: ["item", table, slug],
    queryFn: () => getItem({ data: { table: table as never, slug } }),
    staleTime: 30_000,
  });

export const galleryQuery = (slug: string) =>
  queryOptions({
    queryKey: ["gallery", slug],
    queryFn: () => getGallery({ data: { slug } }),
    staleTime: 30_000,
  });

export const pageQuery = (slug: string) =>
  queryOptions({
    queryKey: ["page", slug],
    queryFn: () => getPage({ data: { slug } }),
    staleTime: 60_000,
  });
